import translations from "./translations.js";
import {formatDate} from "./util.js";

let Data = (()=>{
    let me = {};

    me.init = ()=>{
        let actionTypes = [
            {label:translations.incident_verification,value:"verification"},
            {label:translations.actiontype_referral,value:"referral"},
            {label:translations.actiontype_information,value:"information"},
            {label:translations.actiontype_dialogue,value:"dialogue"},
            {label:translations.actiontype_awareness,value:"awareness"},
            {label:translations.actiontype_advocacy,value:"advocacy"},
            {label:translations.other,value:"other"},
        ]

        let actionModes = [
            {label:translations.mode_phone,value:"phone"},
            {label:translations.mode_email,value:"email"},
            {label:translations.mode_letter,value:"letter"},
            {label:translations.mode_person,value:"person"},
            {label:translations.mode_group,value:"group"},
            {label:translations.other,value:"other"},
        ]

        let actionActors = [
            {label:translations.anr,value:"anr"},
            {label:translations.govt_local,value:"govt_local"},
            {label:translations.govt_regional,value:"govt_regional"},
            {label:translations.govt_national,value:"govt_national"},
            {label:translations.crcc,value:"crcc"},
            {label:translations.actor_company,value:"company"},
            {label:translations.actor_cooperation,value:"cooperation"},
            {label:translations.dgm,value:"dgm"},
            {label:translations.fardc,value:"fardc"},
            {label:translations.fec,value:"fec"},
            {label:translations.armed_group,value:"armed_group"},
            {label:translations.cso,value:"cso"},
            {label:translations.monitorfp,value:"monitorfp"},
            {label:translations.police_pnc,value:"police_pnc"},
            {label:translations.state_service,value:"state_service"},
            {label:translations.private_security,value:"private_security"},
            {label:translations.cls_cps,value:"cls_cps"},
            {label:translations.actor_witness,value:"witness"},
            {label:translations.victim,value:"victim"},
            {label:translations.other,value:"other"},
        ]


        let regions={
            "Haut-Uele":["Dungu","Faradje","Niangara","Rungu","Wamba","Watsa"],
            "Ituri":["Aru","Djugu","Irumu","Mahagi","Mambasa"],
            "Lualaba":["Dilolo","Kapanga","Lubudi","Mutshatsha","Sandoa","Ville de Kolwezi"],
            "Maniema":["Kabambare","Kailo","Kasongo","Kibombo","Kindu","Lubutu","Pangi","Punia"],
            "Nord-Kivu":["Beni","Lubero","Masisi","Nyiragongo","Rutshuru","Walikale"],
            "Sud-Kivu":["Fizi","Idjwi","Kabare","Kalehe","Mwenga","Shabunda","Uvira","Walungu"],
            "Tanganyika":["Kabalo","Kalemie","Kongolo","Manono","Moba","Nyunzu"],
            "Autre province":["Autre territoire"]
        }

        let categories={
            "Accident":["Traffic accident","Asphyxia","Equipment failure","Landslide","Pit collapse","Flooding","Use of explosives","Other"],
            "Roadblock":["Abuse of power","Arbitrary arrest","Bribery","Illegal taxation","Violence","Other"],
            industrial_conflict:["Destruction of rivers","Mining concession invasion","Relocation standards","Other"],
            "Corruption/Fraud":["Mixing origin of minerals","Non-declaration of production","Bribery","Illegal taxation","Selling of iTSCi tags","Other"],
            "Environmental issue":["Poaching","Deforestation","Destruction of rivers","Unfilled holes","Pollution","Use of toxic products","Other"],
            "Child labor":["Crushing or panning","Surface digging","Underground digging","Operating machines","Mineral collection","Transporting","Use of toxic products","Other","None"],
            "Violence":["Armed attack","Fight or quarrel","Vigilantism","Kidnapping","Murder","Torture","Forced labour","Sexual violence","Other"],
            "Theft":["Extorsion","Looting","Armed robbery","Simple Theft","Other"],
            "Other":["Other"],
        }

        let childrenCategories=[
            "Small commerce","Prostitution","Transporting products","Other","None"
        ]

        let responsibleActors = [
            {label:translations.unknown,value:"unknown"},
            {label:translations.anr,value:"anr"},
            {label:translations.actor_company,value:"company"},
            {label:translations.actor_cooperation,value:"cooperation"},
            {label:translations.dgm,value:"dgm"},
            {label:translations.fardc,value:"fardc"},
            {label:translations.armed_group,value:"armed_group"},
            {label:translations.community,value:"community"},
            {label:translations.miners_transporters,value:"miners"},
            {label:translations.police_pnc,value:"police_pnc"},
            {label:translations.state_service,value:"state_service"},
            {label:translations.private_security,value:"private_security"},
            {label:translations.other,value:"other"},
        ]

        let territoireLocations = {
            Rungu:{latitude:2.668,longitude:27.6489255408781},
            Niangara:{latitude:3.512,longitude:27.9016848247627},
            Dungu:{latitude:4.072,longitude:28.4185767921046},
            Wamba:{latitude:2.104,longitude:27.83610526906},
            Faradje:{latitude:3.54,longitude:29.9776464583297},
            Watsa:{latitude:2.737,longitude:29.2605691085919},
            Djugu:{latitude:1.944,longitude:30.3243837352359},
            Mahagi:{latitude:2.354,longitude:30.7133206376299},
            Aru:{latitude:3.067,longitude:30.5332204968841},
            Irumu:{latitude:1.228,longitude:29.9002899111641},
            Mambasa:{latitude:1.494,longitude:28.7779410904815},
            Mutshatsha:{latitude:-10.77,longitude:25.0570728905394},
            Lubudi:{latitude:-10.225,longitude:26.1370602169313},
            "Ville de Kolwezi":{latitude:-10.71484,longitude:25.4667},
            Kapanga:{latitude:-8.4667,longitude:22.4},
            Dilolo:{latitude:-10.6667,longitude:22.3333},
            Sandoa:{latitude:-8.95,longitude:23.95},
            Kindu:{latitude:-2.97,longitude:25.9124992832093},
            Lubutu:{latitude:-0.778,longitude:26.8099739403865},
            Punia:{latitude:-1.712,longitude:26.7807144670867},
            Kabambare:{latitude:-4.541,longitude:27.721021737493},
            Kasongo:{latitude:-4.361,longitude:26.4623205320502},
            Kailo:{latitude:-2.507,longitude:25.6815707364452},
            Pangi:{latitude:-3.188,longitude:26.5655252235655},
            Kibombo:{latitude:-4.075,longitude:25.4277204822976},
            Walikale:{latitude:-1.105,longitude:28.1661663936745},
            Masisi:{latitude:-1.41,longitude:28.8490522552961},
            Rutshuru:{latitude:-1.031,longitude:29.3458253465677},
            Beni:{latitude:0.475,longitude:29.4554831118829},
            Lubero:{latitude:0.036,longitude:28.7485144421101},
            Nyiragongo:{latitude:-1.542,longitude:29.2752332850615},
            Idjwi:{latitude:-2.121,longitude:29.0617094461649},
            Mwenga:{latitude:-3.329,longitude:28.369724436641},
            Shabunda:{latitude:-2.911,longitude:27.5788296464442},
            Fizi:{latitude:-4.24,longitude:28.7160641247728},
            Kalehe:{latitude:-2.074,longitude:28.5993645772594},
            Walungu:{latitude:-2.712,longitude:28.6429882785182},
            Uvira:{latitude:-3.201,longitude:29.0058420033867},
            Kabare:{latitude:-2.424,longitude:28.6403535824063},
            Kongolo:{latitude:-5.366,longitude:26.851731601852},
            Nyunzu:{latitude:-5.727,longitude:27.9358543607606},
            Kalemie:{latitude:-6.007,longitude:28.8233045311648},
            Kabalo:{latitude:-6.256,longitude:26.8903232123947},
            Moba:{latitude:-7.562,longitude:29.5491493249578},
            Manono:{latitude:-7.214,longitude:27.5709788679189}
        }


        me.incidentsSMS={
            profile: "incidents_external",
            fields: [
                /*{label: "id", key: "id", type: "text", isPrimary: true, size: 40}, */
                {label: "report_id", key: "report_id", type: "hidden", isPrimary: true},
                //{label: "coordinates", key: "coordinates", type: "map"},
                {label: translations.date, key: "report_date", type: "date", isPrimary: true, format: "date"},
                {label: translations.status, key: "platform_status", type: "text", isPrimary: true, enumFilter: true},
                {label: translations.localisation, key: "platform_location", type: "text", isPrimary: true, size:250},
                {label: translations.category, key: "platform_category", type: "text", isPrimary: true, enumFilter: true, translate:true},
                {label: translations.assigned, key: "assigned", type: "fk", target:"organisations.name", isPrimary: true},
                {label: translations.archived, key: "archived", type: "boolean"},
                {label: translations.feedback, key: "feedback", type: "textarea"},
            ],
            export:true
        }

        me.incidentsGenericInfo=[
            {type:"caption", label:translations.incident},
            {key: "report_date"},
            {key: "event_date"},
            {key: "platform_status"},
            {key: "assigned"},
            {key: "language"},
        ]

        me.incidentsAssigned={
            profile: "incidents_assigned",
            fields: [
                {label: "report_id", key: "report_id", keyAlt: "id", type: "hidden", isPrimary: true, format:"id"},
                {label: "1: " + translations.summary, type: "caption"},
                //{label: translations.coordinates, key: "coordinates", type: "map",default: "-4,25"},
                {label: translations.date, key: "date", type: "date", isPrimary: true, isRequired: true, format: "date",default: ()=>formatDate(new Date()), onValidate:checkDateIsInPast},
                {label: translations.title, key: "title", type: "text", isPrimary: true, isRequired: true},
                {label: translations.description, key: "description", type: "textarea"},
                {label: translations.status, key: "status", type: "select", values:["Assigné","En cours de suivi","Résolu", "Non résolu", "Persistant", "Non-Suivi"], isPrimary: true, enumFilter: true, hideOnEdit: true},
                {label: "2: " + translations.incident_type, type: "caption"},
                {label: translations.category, key: "category", type: "select", values: Object.keys(categories),child:"subcategory",childValues:categories,isPrimary: true,translate:true,enumFilter: true, isRequired: true,"onChange":setCategoryView},
                {label: translations.children_count, key: "childrenCount", type: "number", collapsed:true},
                {label: translations.subCategory, key: "subcategory", type: "select" , values:[], enumFilter: true, isRequired: true,isPrimary: true,translate:true},
                {label: translations.subCategory2, key: "subcategory2", type: "select" , values:childrenCategories, isPrimary: false, enumFilter: true,translate:true, hasOtherValue:false, collapsed:true},
                {label: "3: " + translations.location, type: "caption"},
                {label: translations.province, key: "province", type: "select", values: Object.keys(regions),child:"territoire",childValues:regions,isPrimary: true,enumFilter: true, isRequired: true},
                {label: translations.territory, key: "territoire", master:"province",type: "select", values:[], isPrimary: true, isRequired: true},
                {label: translations.chiefdomSector, key: "sector", type: "text"},
                {label: translations.groupQuarter, key: "group", type: "text"},
                {label: "4: " + translations.mining_site, type: "caption"},
                {label: translations.miningSite, key: "miningsite", type: "text"},
                {label: "5: " + translations.responsible_actors, type: "caption"},
                {label: "", key: "actors", type: "multiselect", values:responsibleActors,translate:true, enumFilter: false},
                {label: "6: " + translations.other, type: "caption"},
                {label: "pCode", key: "pcode", type: "text", scope:"owner","allowEmpty":true},
                {label: translations.excludeFromApi, key: "noOpenData", type: "boolean"},
                {label: translations.isIncidentCLS, key: "isCLS", type: "boolean"},
                {label: translations.lastModified, key: "lastModified", type: "hidden", isPrimary: true, format: "date"},
                {label: translations.assigned, key: "assigned", type: "fk", target:"organisations.name", isPrimary: true, hideOnEdit: true},
            ],
            export:true,
            canAdd: true
        }

        me.incidentsInfo={
            profile: "incidents_info",
            fields: [
                {label: "report_id", key: "report_id", type: "hidden", isPrimary: true},
                {label: "1: " + translations.summary, type: "caption"},
                {label: translations.date, key: "date", format: "date", type: "date", isPrimary: true, onValidate:checkDateIsInPast},
                {label: translations.title, key: "title", type: "text"},
                {label: translations.description, key: "description", type: "textarea"},
                {label: translations.status, key: "status", type: "select", values:["Assigné","En cours de suivi","Résolu", "Non résolu", "Persistant", "Non-Suivi"], enumFilter: true, hideOnEdit: true},
                {label: "2: " + translations.incident_type, type: "caption"},
                {label: translations.category, key: "category", type: "select", values: Object.keys(categories),child:"subcategory",childValues:categories,enumFilter: true,translate:true,"onChange":setCategoryView},
                {label: translations.children_count, key: "childrenCount", type: "number", collapsed:true},
                {label: translations.subCategory, key: "subcategory", type: "select" , values:[], isPrimary: true, enumFilter: true,translate:true, hasOtherValue:false},
                {label: translations.subCategory2, key: "subcategory2", type: "select" , values:childrenCategories, isPrimary: false, enumFilter: true,translate:true, hasOtherValue:false, collapsed:true},
                {label: "3: " + translations.location, type: "caption"},
                {label: translations.province, key: "province", type: "select", values: Object.keys(regions),child:"territoire",childValues:regions,isPrimary: true},
                {label: translations.territory, key: "territoire", master:"province",type: "select", values:[]},
                {label: translations.chiefdomSector, key: "sector", type: "text"},
                {label: translations.groupQuarter, key: "group", type: "text"},
                {label: "4: " + translations.mining_site, type: "caption"},
                {label: translations.miningSite, key: "miningsite", type: "text"},
                {label: "5: " + translations.responsible_actors, type: "caption", id:"responsibleActorsLabel"},
                {label: "", key: "actors", type: "multiselect", values:responsibleActors,translate:true, enumFilter: false, id:"responsibleActors"},
                {label: "6: " + translations.other, type: "caption"},
                {label: "pCode", key: "pcode", type: "text", scope:"owner","allowEmpty":true},
                {label: translations.excludeFromApi, key: "noOpenData", type: "boolean"},
                {label: translations.isIncidentCLS, key: "isCLS", type: "boolean"},
                {label: translations.lastModified, key: "lastModified", type: "hidden", isPrimary: true}
            ],
        }

        me.users={
            profile: "users",
            name: "Utilisateur",
            fields: [
                {label: "id", key: "id", type: "hidden"},
                {label: translations.username, key: "username", type: "text", isPrimary: true},
                {label: translations.fullname, key: "fullname", type: "text", isPrimary: true},
                {label: translations.email, key: "email", type: "text", isPrimary: true},
                {label: translations.initial, key: "temporaryPassword", type: "password", default: '***' },
                {label: translations.role, key: "role", type: "select", values:[
                        {label:translations.user,value:"user"},
                        {label:translations.admin,value:"admin"},
                        {label:translations.owner,value:"owner"},
                    ], isPrimary: true,translate:true},
                {label: translations.organisation, key: "organisation", type: "fk", target:"organisations.name",isPrimary: true},
                {label: translations.preferedLanguage, key: "language", type: "select" , values:["fr","en"]},
                {label: translations.emailnotifications, key: "emailnotifications", type: "boolean" , default: false},
                {label: translations.active, key: "active", type: "boolean", default: true, isPrimary: true},
                {label: translations.lastModified, key: "lastModified", type: "hidden", isPrimary: true, format: "date"},
            ],
            export:true,
            canAdd: true,
            canDelete: true,
        }

        me.organisations={
            profile: "organisations",
            name: "Organisation",
            fields: [
                {label: "id", key: "id", type: "hidden"},
                {label: translations.shortName, key: "name", type: "text", isPrimary: true},
                {label: translations.fullName, key: "fullname", type: "text", isPrimary: true},
            ],
            export:true,
            canAdd: true,
            canDelete: true,
        }

        me.actions={
            profile: "actions",
            name: "Actions",
            fields: [
                {label: "id", key: "id", type: "hidden"},
                {label: translations.date, key: "date", type: "date", format: "date",isRequired:true, onValidate:checkDateIsInPast},
                {label: translations.action_type, key: "type", type: "select",values:actionTypes,isRequired:true,isPrimary: true},
                {label: translations.action_mode, key: "mode", type: "select",values:actionModes,isRequired:true, isPrimary: true},
                {label: translations.action_actors, key: "actors", type: "multiselect",values:actionActors,isRequired:true,isPrimary: true},
                {label: translations.description, key: "description", type: "textarea",isRequired:true,isPrimary: true,translateContent:true},
                {label: translations.lastModified, key: "lastModified", type: "hidden", format: "date"},
            ]
        }
    }


    function setCategoryView(value,formConfig){
        let editor = formConfig.editors.find(editor=>editor.key==="childrenCount");
        let editor2 = formConfig.editors.find(editor=>editor.key==="subcategory2");
        let collapsed = value !== "Child labor";
        if (editor) editor.input.closest(".fieldset").classList.toggle("collapsed",collapsed);
        if (editor2) editor2.element.closest(".fieldset").classList.toggle("collapsed",collapsed);


        let actorCategories = ["Roadblock","Corruption/Fraud","Environmental issue","Violence","Theft"];
        collapsed = actorCategories.indexOf(value) < 0;
        let actorEditor = formConfig.editors.find(editor=>editor.key==="actors");
        if (actorEditor){
            let fieldset = actorEditor.element.closest(".fieldset");
            let label = fieldset.previousSibling;
            fieldset.classList.toggle("collapsed",collapsed);
            if (label) label.classList.toggle("collapsed",collapsed);
        }

    }

    function checkChildLabourValue(editors,value){
        if (value) return true;
        let categoryEditor = editors.find(item=> item.key==="category");
        if (categoryEditor){
            let parentValue = categoryEditor.input?categoryEditor.input.value:categoryEditor.getValue();
            if (parentValue === "Child labor" && !value){
                return false;
            }
        }
        return true;
    }

    function checkDateIsInPast(editors,value){
        if (!value) return false;

        const now = new Date();
        const margin = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
        const futureTime = now.getTime() + margin;

        let date = new Date(value);
        // check for invalid date
        if (isNaN(date.getTime())) {
            return false;
        }

        let isInPast = date.getTime() < futureTime;
        return isInPast;
    }

    return me;
})();
export default Data;